function InjuryIcon({
  size = 28,
  iconSize = '1.2rem',
  className = '',
  style = {},
  title = 'Infortunato'
}) {
  return (
    <span
      className={`wrestlers-injury-badge shadow-sm d-inline-flex align-items-center justify-content-center rounded-circle ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        border: 'none',
        ...style
      }}
      title={title}
      aria-label={title}
    >
      <i className="bi bi-bandaid-fill text-danger" style={{ fontSize: iconSize }} />
    </span>
  );
}

export default InjuryIcon;
